// Safari reports invalid JSON as “The string did not match the expected pattern”.
// Never expose transport/parser diagnostics as the user's simulation result.
export async function readSimulationResponse(response) {
  if (!response.ok) throw Object.assign(new Error('Simulation request failed'), { status: response.status });
  try { return await response.json(); }
  catch { throw Object.assign(new Error('Invalid simulation response'), { code: 'INVALID_RESPONSE' }); }
}
export function simulationErrorMessage(error, t) {
  if (error?.status === 401 || error?.status === 403) return t('help.simulationUI.errors.access');
  return t('help.simulationUI.errors.retry');
}
